import type { NormalizedError } from "@skaile/workspaces/types";

export function normalizeError(value: unknown): NormalizedError | undefined {
  if (value === undefined || value === null) return undefined;
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack,
    };
  }
  if (typeof value === "string") {
    return { name: "Error", message: value };
  }
  try {
    return { name: "Error", message: JSON.stringify(value) };
  } catch {
    return { name: "Error", message: String(value) };
  }
}

export function sanitizeData(value: unknown): Record<string, unknown> | undefined {
  if (value === undefined || value === null) return undefined;
  const seen = new WeakSet<object>();
  const walk = (v: unknown): unknown => {
    if (v === null || v === undefined) return v;
    if (typeof v === "bigint") return v.toString();
    if (typeof v === "function") return "[Function]";
    if (typeof v === "symbol") return v.toString();
    if (v instanceof Error) return normalizeError(v);
    if (typeof v !== "object") return v;
    if (seen.has(v as object)) return "[Circular]";
    seen.add(v as object);
    if (Array.isArray(v)) return v.map(walk);
    const out: Record<string, unknown> = {};
    for (const [k, child] of Object.entries(v as Record<string, unknown>)) {
      out[k] = walk(child);
    }
    return out;
  };
  const result = walk(value);
  if (typeof result !== "object" || result === null || Array.isArray(result)) {
    return { value: result };
  }
  return result as Record<string, unknown>;
}
